import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcComponent } from '../fc';
/**
 * fc-layoutpanelé¢æ¿å¸å±
 * 
 * é¢æ¿ç»ä»¶ã
 * 
 * è®¾ç½®é¢æ¿æå¯ç»åå®¹åºåã
 * 
 */
@Component({
    selector: 'fc-layoutpanel',
    template: `
    <div class="fc-layoutpanel"    [ngClass]="{'fc-full':fcFull,fcClass:fcClass!==undefined}">
        <div class="fc-header">
            <ng-content select="[fcheader]"></ng-content>
        </div>  
        <div class="fc-toolbar">
            <ng-content select="[fctoolbar]"></ng-content>
        </div>      
        <div class="fc-content">
            <ng-content select="[fccontent]"></ng-content>
        </div>
        <div class="fc-footer">
            <ng-content select="[fcfooter]"></ng-content>
        </div>
    </div>
    `,
    styles: [`
    .fc-layoutpanel{
        display: block;
        width: 100%;
        position: relative;
        box-sizing:border-box;
        background-color:#ffffff;
    }  
    .fc-full{
        width:100%;
        height:100%;
    }
    .fc-full .fc-content{
        width:100%;
        height:100%;
    }
    `]
})
export class FclayoutpanelComponent extends FcComponent {
     /**å®½é«100%ç»§æ¿ä¸ä¸ä¸ªçå®½é«*/
    @Input()
    fcFull: boolean = false;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-layoutpanel');
    }
}
